import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from './service-requirement-group.actions';
import * as fromGraphql from './service-requirement-group.graphql';


@Injectable()
export class ServiceRequirementGroupEffects {
  createServiceRequirementGroupMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceRequirementGroupMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_REQUIREMENTS_GROUP,
        variables: {
          input: action?.input
        }
      })
      .pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {
          console.log(data)
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertServiceRequirementGroup({ serviceRequirementGroup: result?.data })
              );
              this.notificationService.successMessage('Created Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateServiceRequirementGroupMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateServiceRequirementGroupMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_SERVICE_REQUIREMENTS_GROUP,
        variables: {
          input: action?.input
        }
      })
      .pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertServiceRequirementGroup({ serviceRequirementGroup: result?.data })
              );
              this.notificationService.successMessage('Updated Successfully');
            }
            else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteServiceRequirementGroupMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deleteServiceRequirementGroupMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_SERVICE_REQUIREMENTS_GROUP,
        variables: {
          requirementGroupUniqueId: action?.requirementGroupUniqueId
        }
      })
      .pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceRequirementGroup({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceRequirementGroups = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceRequirementGroups),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SERVICE_REQUIREMENTS_GROUPS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      })
      .pipe(
        this.notificationService.catchError('Problem occurred while fetching service groups'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceRequirementGroups({ serviceRequirementGroups: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
